import { render, staticRenderFns } from "./PermissionSetting.vue?vue&type=template&id=141dfc27&scoped=true&"
import script from "./PermissionSetting.vue?vue&type=script&lang=js&"
export * from "./PermissionSetting.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSetting.vue?vue&type=style&index=0&id=141dfc27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141dfc27",
  null
  
)

export default component.exports